export const darkColors = {
  paper: '#161616',
  backgroundDefault: '#141B22',
  divider: '#979CA4',
  error: '#f44336',
  primary: 'rgb(252, 212, 5)',
  success: '#4caf50',

  text: '#ffffff',
  contrastText: '#ffffff',
  textSecondary: '#919eab',
  textPrimaryContrast: '#202020',
  linearGradient: 'linear-gradient(180deg, #313E4B 0%, #1F2934 100%)',
  warning: '#ff9800',

  primaryLight: 'rgb(252, 212, 5)',
  primaryDark: '#d8b941',
  secondaryLight: '#757575',
  secondaryDark: '#141B22',

  darkGray: '#3d4551',
  lightGray: '#71767A',
  mediumGray: '#565c65',
  dimWhite: '#f0f0f0',

  global: {
    yellow: 'rgb(252, 212, 5)',
    lightGray: '#979CA4',
    darkBlueGray: '#1F2934',
    ibBlack: '#141B22',
    lightBlueGray: '#354256',
    dimWhite: '#f0f0f0',
    primaryRed: '#D83933',
  },

  agentBuilder: {
    divider: '#ccc',
    dimOutline: '#474d66',
    dimPrimary: '#d8b941',
    selectedNodeBackground: '#354256',
    selectedNodeBackgroundHover: '#3f4a5a',
    selectedNodeBackgroundActive: '#2e3847',
    label: '#c2c2c2',
    promptTextBackground: '#565C65',
    accordionBackground: '#26323F',
    accordionBackgroundHover: '#2d3a48',
    accordionRowBackground: '#3D4551',
  },
  canvasHeader: {
    buttonBorderPrimary: '#F0F1F2',
    primaryDark: '#26323F',
  },
  agentChat: {
    lightGray: '#71767A',
    secondaryGray: '#5F6368',
    mediumGray: '#565c65',
    darkGray: '#3d4551',
    infoBlue: '#B1D1E3',
    alertRed: '#CE6158',
  },
}

export const lightColors = {
  paper: '#ffffff',
  backgroundDefault: '#f4f5f7',
  border: 'rgba(0, 0, 0, 0.12)',
  error: '#f44336',
  primary: '#5664d2',
  success: '#4caf50',
  warning: '#ff9800',
  actionActive: '#6b778c',

  text: '#172b4d',
  contrastText: '#ffffff',
  textSecondary: '#6b778c',
}
